module.exports = __webpack_public_path__ + "static/media/logo9.46d1b11f.png";